import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import classes from "./ImportTransaction4.module.css";
import Header from "../../Components/Header/Header";
import Sidebar from "../../Components/Sidebar/Sidebar";
import {
    ChevronLeft,
    ChevronRight,
    CheckCircle,
    XCircle,
    AlertCircle,
    Download,
    FileText,
    Eye,
    ArrowLeft,
    Home,
    Upload,
    RefreshCw
} from "lucide-react";
import CheckIcon from "../../Assets/mark.png";
import SuccessIcon from "../../Assets/successfully.png";
import FailedIcon from "../../Assets/failed.png";
import SkippedIcon from "../../Assets/skipped.png";
import TotalIcon from "../../Assets/rows.png";

const ImportTransaction4 = () => {
    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(100);
    // Add this function with your other handle functions (around line 15-20)
    const handleGoToReconciliation = () => {
        navigate("/Reconcilation");
    };

    // Update the button (at the bottom of the component)
    <button
        className={classes.goToReconciliationBtn}
        onClick={handleGoToReconciliation}
    >
        <RefreshCw size={16} />
        Go to Reconciliation Runs
    </button>
    const handleBackClick = () => {
        navigate("/ImportTransactions");
    };
    <button
        className={classes.backToBankBtn}
        onClick={handleBackClick}
    >
        <ArrowLeft size={16} />
        Back to Bank Transactions
    </button>
    const steps = [
        {
            id: 1,
            label: "Upload File",
            description: "File uploaded",
            completed: true,
            number: 1
        },
        {
            id: 2,
            label: "Map Columns",
            description: "Columns mapped",
            completed: true,
            number: 2
        },
        {
            id: 3,
            label: "Preview Data",
            description: "Review and validate data",
            completed: true,
            number: 3
        },
        {
            id: 4,
            label: "Import Summary",
            description: "Complete the import",
            completed: false,
            active: true,
            number: 4
        }
    ];

    const stats = [
        {
            label: "Imported Successfully",
            value: "1,242",
            percentage: "99.36%",
            icon: SuccessIcon,
            color: "#22c55e"
        },
        {
            label: "Skipped",
            value: "8",
            percentage: "0.64%",
            icon: SkippedIcon,
            color: "#f59e0b"
        },
        {
            label: "Failed",
            value: "0",
            percentage: "0.00%",
            icon: FailedIcon,
            color: "#ef4444"
        },
        {
            label: "Total Rows",
            value: "1,250",
            percentage: "100%",
            icon: TotalIcon,
            color: "#6366f1"
        }
    ];

    const summaryData = [
        { label: "File Name", value: "Access_Bank_Statement_AUG2026.csv" },
        { label: "Data Source", value: "Access Bank - Main Account" },
        { label: "Imported By", value: "Adekunle Olatunji" },
        { label: "Imported On", value: "14 Aug 2026, 10:45 AM" },
        { label: "Total Rows in File", value: "1,250" },
        { label: "Import Run ID", value: "IMP-2026-08-14-0007" }
    ];

    // Pie chart data with correct colors
    const pieData = [
        { label: "Matched", value: 99.36, color: "#15803D" },
        { label: "Skipped", value: 0.64, color: "#f59e0b" },
        { label: "Exceptions", value: 0.00, color: "#ef4444" }
    ];

    // Calculate pie chart segments with thinner rims - BIGGER circle
    const totalPieValue = pieData.reduce((sum, item) => sum + item.value, 0);
    let currentAngle = 0;
    const pieSegments = pieData.map(item => {
        const percentage = (item.value / totalPieValue) * 100;
        const angle = (percentage / 100) * 360;
        const startAngle = currentAngle;
        const endAngle = currentAngle + angle;
        currentAngle = endAngle;

        // Use radius 48 for outer and inner circle radius 38 for VERY thin rims
        const startRad = (startAngle - 90) * Math.PI / 180;
        const endRad = (endAngle - 90) * Math.PI / 180;
        const x1 = 50 + 48 * Math.cos(startRad);
        const y1 = 50 + 48 * Math.sin(startRad);
        const x2 = 50 + 48 * Math.cos(endRad);
        const y2 = 50 + 48 * Math.sin(endRad);
        const largeArc = angle > 180 ? 1 : 0;

        return {
            ...item,
            path: `M 50 50 L ${x1} ${y1} A 48 48 0 ${largeArc} 1 ${x2} ${y2} Z`,
            percentage: percentage.toFixed(2)
        };
    });

    // Generate 100 skipped rows
    const generateSkippedRows = () => {
        const rows = [];
        const reasons = [
            "Duplicate transaction (Reference already exists)",
            "Validation error (Invalid amount)",
            "Missing required field",
            "Invalid date format",
            "Amount mismatch"
        ];
        const narrations = [
            "Transfer to Supplier B",
            "Customer Payment",
            "Interest Received",
            "Bank Charges",
            "POS Purchase",
            "Salary Payment",
            "Utility Bill",
            "Rent Payment",
            "Supplier Payment",
            "Insurance Premium"
        ];

        for (let i = 1; i <= 105; i++) {
            const reasonIndex = i % reasons.length;
            const narrationIndex = i % narrations.length;
            rows.push({
                rowNumber: i,
                reference: `TRF/202608${String(10 - (i % 7)).padStart(2, '0')}/${String(i).padStart(3, '0')}`,
                date: `${String(14 - (i % 7)).padStart(2, '0')}-08-26`,
                narration: narrations[narrationIndex],
                amount: (Math.random() * 100000 + 1000).toFixed(2),
                reason: reasons[reasonIndex]
            });
        }
        return rows;
    };

    const skippedRows = generateSkippedRows();
    const totalSkipped = skippedRows.length;
    const totalPages = Math.ceil(totalSkipped / rowsPerPage);
    const startIndex = (currentPage - 1) * rowsPerPage;
    const endIndex = Math.min(startIndex + rowsPerPage, totalSkipped);
    const currentSkippedRows = skippedRows.slice(startIndex, endIndex);

    const handlePageChange = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    const getPageNumbers = () => {
        const pages = [];
        const maxVisible = 5;

        if (totalPages <= maxVisible) {
            for (let i = 1; i <= totalPages; i++) {
                pages.push(i);
            }
        } else {
            pages.push(1);

            let start = Math.max(2, currentPage - 1);
            let end = Math.min(totalPages - 1, currentPage + 1);

            if (currentPage <= 3) {
                end = 4;
            }
            if (currentPage >= totalPages - 2) {
                start = totalPages - 3;
            }

            if (start > 2) {
                pages.push('...');
            }

            for (let i = start; i <= end; i++) {
                pages.push(i);
            }

            if (end < totalPages - 1) {
                pages.push('...');
            }

            pages.push(totalPages);
        }

        return pages;
    };

    return (
        <div className={classes.page}>
            <Header />
            <Sidebar />

            <main className={classes.main}>
                <div className={classes.container}>
                    {/* Header Section */}
                    <div className={classes.headerSection}>
                        <div>
                            <h1 className={classes.title}>Import Transactions</h1>
                            <p className={classes.subtitle}>Import bank statement of transaction files into the system</p>
                        </div>
                    </div>

                    {/* Step Indicator */}
                    <div className={classes.stepsContainer}>
                        {steps.map((step, index) => (
                            <React.Fragment key={step.id}>
                                <div className={classes.stepWrapper}>
                                    <div className={`${classes.stepCircle} ${step.completed ? classes.stepCompleted : ''} ${step.active ? classes.stepActive : ''}`}>
                                        {step.completed ? (
                                            <img src={CheckIcon} alt="completed" className={classes.stepIcon} />
                                        ) : (
                                            <span className={classes.stepNumber}>{step.number}</span>
                                        )}
                                    </div>
                                    <div className={classes.stepContent}>
                                        <div className={`${classes.stepLabel} ${step.active ? classes.stepLabelActive : ''} ${step.completed ? classes.stepLabelCompleted : ''}`}>
                                            {step.id}. {step.label}
                                        </div>
                                        <div className={classes.stepDescription}>{step.description}</div>
                                    </div>
                                </div>
                                {index < steps.length - 1 && (
                                    <div className={`${classes.stepLine} ${step.completed ? classes.stepLineCompleted : ''}`}></div>
                                )}
                            </React.Fragment>
                        ))}
                    </div>

                    {/* Stats Cards with Percentages */}
                    <div className={classes.statsGrid}>
                        {stats.map((stat, index) => (
                            <div key={index} className={classes.statCard}>
                                <div className={classes.statIcon}>
                                    <img src={stat.icon} alt={stat.label} className={classes.statImage} />
                                </div>
                                <div className={classes.statInfo}>
                                    <div className={classes.statLabel}>{stat.label}</div>
                                    <div className={classes.statValue}>{stat.value}</div>
                                    <div className={classes.statPercentage}>{stat.percentage}</div>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Import Summary - Two Boxes Side by Side */}
                    <div className={classes.summaryWrapper}>
                        {/* Box 1: Success Message + Import Summary Details */}
                        <div className={classes.summaryBox}>
                            <div className={classes.successSection}>
                                <div className={classes.successIconWrapper}>
                                    <img src={CheckIcon} alt="success" className={classes.successCheckIcon} />
                                </div>
                                <div className={classes.successContent}>
                                    <h2 className={classes.successTitle}>Import Completed Successfully!</h2>
                                    <p className={classes.successSubtitle}>Your transactions have been imported and are ready for reconciliation</p>
                                </div>
                            </div>

                            <div className={classes.summaryList}>
                                {summaryData.map((item, index) => (
                                    <div key={index} className={classes.summaryRow}>
                                        <span className={classes.summaryLabel}>{item.label}</span>
                                        <span className={classes.summaryValue}>{item.value}</span>
                                    </div>
                                ))}
                            </div>
                            <div className={classes.summaryActions}>
                                <button className={classes.downloadReportBtn}>
                                    <Download size={16} />
                                    Download Import Report
                                </button>
                                <button className={classes.viewLogBtn}>
                                    <Eye size={16} />
                                    View Import Log
                                </button>
                            </div>
                        </div>

                        {/* Box 2: Pie Chart & Percentages */}
                        <div className={classes.pieBox}>
                            <h3 className={classes.sectionTitle}>Import Summary</h3>
                            <div className={classes.pieContent}>
                                <div className={classes.pieChartContainer}>
                                    <div className={classes.pieChart}>
                                        <svg viewBox="0 0 100 100" className={classes.pieSvg}>
                                            {pieSegments.map((segment, index) => (
                                                <path
                                                    key={index}
                                                    d={segment.path}
                                                    fill={segment.color}
                                                    className={classes.pieSegment}
                                                />
                                            ))}
                                            {/* Inner circle - VERY LARGE hole for THIN rims */}
                                            <circle cx="50" cy="50" r="38" fill="white" />
                                            {/* Center Text - Single line */}
                                            <text
                                                x="50"
                                                y="44"
                                                className={classes.pieCenterValue}
                                                textAnchor="middle"
                                            >
                                                99.36%
                                            </text>
                                            <text
                                                x="50"
                                                y="58"
                                                className={classes.pieCenterLabel}
                                                textAnchor="middle"
                                            >
                                                Successfully Imported
                                            </text>
                                        </svg>
                                    </div>
                                </div>
                                <div className={classes.pieStats}>
                                    <div className={classes.pieLegend}>
                                        {pieData.map((item, index) => (
                                            <div key={index} className={classes.legendItem}>
                                                <span className={classes.legendDot} style={{ backgroundColor: item.color }}></span>
                                                <span className={classes.legendLabel}>{item.label}</span>
                                                <span className={classes.legendValue} style={{ color: item.color }}>
                                                    {item.value}%
                                                </span>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Skipped Rows Section */}
                    {/* Skipped Rows Section */}
                    <div className={classes.skippedSection}>
                        <div className={classes.skippedHeader}>
                            <div className={classes.skippedHeaderLeft}>
                                <h3 className={classes.skippedTitle}>Skipped Rows ({totalSkipped})</h3>
                                <p className={classes.skippedSubtitle}>These rows were skipped due to duplicates or validation issues</p>
                            </div>
                            <button className={classes.downloadSkippedBtn}>
                                <Download size={16} />
                                Download Skipped Rows
                            </button>
                        </div>

                        <div className={classes.tableWrapper}>
                            <div className={classes.tableContainer}>
                                <table className={classes.table}>
                                    <thead>
                                        <tr>
                                            <th>Row Number</th>
                                            <th>Reference / Date</th>
                                            <th>Narration</th>
                                            <th>Amount (₦)</th>
                                            <th>Reason</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentSkippedRows.map((item, index) => (
                                            <tr key={index}>
                                                <td>{item.rowNumber}</td>
                                                <td>
                                                    <div className={classes.reference}>{item.reference}</div>
                                                    <div className={classes.date}>{item.date}</div>
                                                </td>
                                                <td>{item.narration}</td>
                                                <td>{Number(item.amount).toLocaleString()}</td>
                                                <td>{item.reason}</td>
                                                <td>
                                                    <button className={classes.viewBtn}>
                                                        {/* <Eye size={14} /> */}
                                                        View
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div className={classes.tablePagination}>
                            <span className={classes.paginationInfo}>
                                Showing {totalSkipped > 0 ? startIndex + 1 : 0} to {endIndex} of {totalSkipped} skipped rows
                            </span>
                            <div className={classes.paginationControls}>
                                <button
                                    className={classes.pageButton}
                                    onClick={() => handlePageChange(currentPage - 1)}
                                    disabled={currentPage === 1 || totalPages === 0}
                                >
                                    <ChevronLeft size={16} />
                                    Previous
                                </button>
                                {getPageNumbers().map((page, index) => (
                                    <button
                                        key={index}
                                        className={`${classes.pageButton} ${page === currentPage ? classes.activePage : ''}`}
                                        onClick={() => typeof page === 'number' && handlePageChange(page)}
                                        disabled={page === '...'}
                                    >
                                        {page}
                                    </button>
                                ))}
                                <button
                                    className={classes.pageButton}
                                    onClick={() => handlePageChange(currentPage + 1)}
                                    disabled={currentPage === totalPages || totalPages === 0}
                                >
                                    Next
                                    <ChevronRight size={16} />
                                </button>
                            </div>
                        </div>
                    </div>
                    {/* Bottom Navigation Buttons */}
                    <div className={classes.bottomButtons}>
                        <button
                            className={classes.backToBankBtn}
                            onClick={handleBackClick}
                        >
                            <ArrowLeft size={16} />
                            Back to Bank Transactions
                        </button>
                        <button className={classes.importAnotherBtn}>
                            <Upload size={16} />
                            Import Another File
                        </button>
                        <button
                            className={classes.goToReconciliationBtn}
                            onClick={handleGoToReconciliation}
                        >
                            <RefreshCw size={16} />
                            Go to Reconciliation Runs
                        </button>
                    </div>
                </div>
            </main>
        </div>
    );
};

export default ImportTransaction4;